// A Bullhorn custom tab says what kind of record it sits on through the
// entityType in its URL, and a Contact or Company tab copied from the Candidate
// tab still says "candidate". The server looks the id up in Bullhorn and reports
// what it really is; this decides whether the page should switch to that.
//
// Only a tab that claimed 'candidate' is ever switched, and only to contact or
// company. Every explicitly-typed tab (contact, placement, company, ...) keeps
// exactly the type its URL gave it, and a candidate is never "corrected" away
// from candidate on the strength of a lookup.
export function entityTypeToAdopt(currentType, serverType) {
  if (currentType !== 'candidate') return null;
  return serverType === 'contact' || serverType === 'company' ? serverType : null;
}
